import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navigation/Navbar';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import SellerOffersDashboard from '../components/SellerOffersDashboard';
import PlatformPageHeader from '../components/Common/PlatformPageHeader';
import { Box, Container } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const ReceivedOffersPage = () => {
  const { t } = useTranslation();
  
  return (
    <SciFiBackground>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <Box component="main" sx={{ flex: 1, display: 'flex', py: { xs: 5, md: 8 }, px: 2 }}>
          <Container maxWidth="lg">
            <PlatformPageHeader
              icon={InboxIcon}
              eyebrow={t('nav.receivedOffers', 'Inbox')}
              title={t('receivedOffers.title')}
              subtitle={t('receivedOffers.subtitle')}
            />
            <SellerOffersDashboard />
          </Container>
        </Box>
      </Box>
    </SciFiBackground>
  );
};

export default ReceivedOffersPage;
